module.exports = __webpack_public_path__ + "static/media/15.84b8086b.jpg";